import ControlProps from '../../../mixins/ControlProps';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';
import { TimePickerProperty } from '../enums';
import {
  DEFAULT_APM_LABEL,
  DEFAULT_HOUR_INTERVAL,
  DEFAULT_HOUR_LABEL,
  DEFAULT_MINUTE_INTERVAL,
  DEFAULT_MINUTE_LABEL,
  DEFAULT_TIME_FORMAT,
} from '../constants';

const TimePickerProps = {
  props: {
    ...ControlProps.props,
    [TimePickerProperty.FillType]: InputProps.props[InputProperty.FillType],
    [TimePickerProperty.Format]: {
      default: DEFAULT_TIME_FORMAT,
      type: String,
    },
    [TimePickerProperty.MinuteRange]: {
      default: () => null,
      type: Array,
    },
    [TimePickerProperty.HourRange]: {
      default: () => null,
      type: Array,
    },
    [TimePickerProperty.MinuteInterval]: {
      default: DEFAULT_MINUTE_INTERVAL,
      type: Number,
    },
    [TimePickerProperty.HourInterval]: {
      default: DEFAULT_HOUR_INTERVAL,
      type: Number,
    },
    [TimePickerProperty.MinuteLabel]: {
      default: DEFAULT_MINUTE_LABEL,
      type: String,
    },
    [TimePickerProperty.HourLabel]: {
      default: DEFAULT_HOUR_LABEL,
      type: String,
    },
    [TimePickerProperty.APMLabel]: {
      default: DEFAULT_APM_LABEL,
      type: String,
    },
  },
};

export default TimePickerProps;
